module.exports = __webpack_public_path__ + "img/inno-wave.8b09698a.png";